module.exports = __webpack_public_path__ + "img/person-add.75dbb14e.svg";